<template>
  <div class="proudof p-4">
    <div class="flex flex-initial">
      <h3 class="text-2xl mb-6 border-b-2 border-solid border-gray-400 text-gray-600 font-light mb-1">What am
        I proud of?</h3>
    </div>

    <div class="text p-4 text-black">

      <div>
        <!--              <div class="flex items-center">-->
        <div class="flex py-4">
          <div
              class="inline-flex flex-shrink-0 items-center items-baseline justify-center leading-none align-text-bottom text-black mr-6 text-xl">
            <font-awesome-icon :icon="['fas', 'question-circle']"></font-awesome-icon>
          </div>
          <div class="">
            <p class="text-l font-bold">Answered 10M+ questions!</p>
            <small>hoi hoi</small>
          </div>
        </div>
      </div>

      <div>
        <!--              <div class="flex items-center">-->
        <div class="flex py-4">
          <div
              class="inline-flex flex-shrink-0 items-center items-baseline justify-center leading-none align-text-bottom text-black mr-6 text-xl">
            <font-awesome-icon :icon="['fas', 'music']"></font-awesome-icon>
          </div>
          <div class="">
            <p class="text-l font-bold">Made people enjoy and learn a new language for equivalent of 29+ years
              (older than myself!)
            </p>
            <small>hoi hoi</small>
          </div>
        </div>
      </div>


      <div>
        <!--              <div class="flex items-center">-->
        <div class="flex py-4">
          <div
              class="inline-flex flex-shrink-0 items-center items-baseline justify-center leading-none align-text-bottom text-black mr-6 text-xl">
            <font-awesome-icon :icon="['fas', 'hourglass-start']"></font-awesome-icon>
          </div>
          <div class="">
            <p class="text-l font-bold">Saved +110 days of time of students, writers and etc!
            </p>
            <small>hoi hoi</small>
          </div>
        </div>
      </div>

      <div>
        <!--              <div class="flex items-center">-->
        <div class="flex py-4">
          <div
              class="inline-flex flex-shrink-0 items-center items-baseline justify-center leading-none align-text-bottom text-black mr-6 text-xl">
            <font-awesome-icon :icon="['fas', 'user-friends']"></font-awesome-icon>
          </div>
          <div class="">
            <p class="text-l font-bold">Tried to cover small part of 7 people expenses.</p>
            <small>hoi hoi</small>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
name: "Accomplishments",
  data() {
    return {
    }
  },
}
</script>

<style scoped lang="scss">

</style>
